import axios from 'axios';

export default (getOptions) => ({
    Active: (id) => axios.post(`/api/invention/session/pvt/active/${id}`, {}, getOptions()),
});
